
<div class="c-search-highlights-tags">
  <h3
    class="c-search-tags__title"
    :class="[
      { 'is-loading': isLoading },
      previewClass
    ]"
  >
    {{ title }}
  </h3>

  <div
    class="c-search-tags__items"
    :class="[previewClass]"
  >
    <template v-if="cards.length">
      <button
        v-for="(card, index) in cards"
        v-show="isLoading || card.label"
        :key="`tag-${card.label}-${index}`"
        class="c-search-tags__button"
        :class="[
          { 'is-loading': isLoading },
          previewClass
        ]"
        @click.prevent="chooseSearchTag(card)"
      >
        {{ card.label }}
      </button>
    </template>

    <span v-else>
      <slot />
    </span>
  </div>
</div>
